import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store, StoreCategory, StoreCategoryTitle, StoreCategoryTitleMapper, StoreType } from '../../data-access/models/store.type';
import { StoresApiService } from '../../data-access/services/stores-api.service';
import { StorePreviewComponent } from '../store-preview/store-preview.component';
import { HorizontalScrollComponent, TitleSummaryComponent } from '@client-monorepo/common/ui-components';
import { storeCategories, StoreRestrictionFields } from '../../data-access/constants/stores.const';
import { NgxChipComponent } from '@digipay/ngx-chip';
import { OrderTypes, RestrictionTypes, SearchPayloadInterface } from '@client-monorepo/common/network';
import { Router } from '@angular/router';

@Component({
  selector: 'daily-stores-personalized-onsite-stores',
  standalone: true,
  imports: [CommonModule, StorePreviewComponent, TitleSummaryComponent, HorizontalScrollComponent, NgxChipComponent],
  templateUrl: './personalized-onsite-stores.component.html',
  styleUrl: './personalized-onsite-stores.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalizedOnsiteStoresComponent implements OnInit {
  stores = signal<Array<Array<Store | undefined>>>([]);
  categories = storeCategories;
  selectedCategory = signal<StoreCategory | undefined>(undefined);
  StoreCategoryTitleMapper = StoreCategoryTitleMapper;

  storesApi = inject(StoresApiService);
  router = inject(Router);
  ngOnInit(): void {
    this.getPersonalizedStores();
  }

  getPersonalizedStores(): void {
    const payload: SearchPayloadInterface<StoreRestrictionFields> = {
      restrictions: [
        {
          type: RestrictionTypes.COLLECTION,
          values: [StoreType.ONSITE],
          field: StoreRestrictionFields.STORE_TYPE,
        },
      ],
      orders: [
        {
          field: 'distance',
          order: OrderTypes.ASC,
        },
      ],
    };
    if (this.selectedCategory()) {
      const oldCategoryIndex = payload.restrictions.findIndex((r) => r.field === StoreRestrictionFields.CATEGORIES);
      if (oldCategoryIndex !== -1) {
        payload.restrictions.splice(oldCategoryIndex, 1);
      }

      payload.restrictions.push({
        type: RestrictionTypes.COLLECTION,
        values: [StoreCategoryTitle[this.selectedCategory()!.title]],
        field: StoreRestrictionFields.CATEGORIES,
      });
    }
    this.storesApi.getAllStores(payload).subscribe((stores) => {
      this.chunkStores(stores);
    });
  }

  chunkStores(stores: Store[]): void {
    const grouped: Array<Array<Store | undefined>> = [];
    for (let i = 0; i < stores.length; i += 2) {
      grouped.push([stores[i], stores.length === i + 1 ? undefined : stores[i + 1]]);
    }
    this.stores.set(grouped);
  }

  changeCategory(category: StoreCategory | undefined = undefined): void {
    this.selectedCategory.set(category);
    this.getPersonalizedStores();
  }

  goToStorePage(title: string): void {
    this.router.navigate(['/stores', title]);
  }
}
